export function deriveSectionStatus(content: string | null | undefined): 'captured' | 'not_captured' {
  return (content?.trim().length ?? 0) > 0 ? 'captured' : 'not_captured';
}
